var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.createDelete)?_c('v-btn',{staticClass:"mr-2",attrs:{"icon":"","color":"red lighten-2"},on:{"click":_vm.deleteConfirm}},[_c('v-icon',[_vm._v(" fa fa-trash ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }